export default __webpack_public_path__ + "images/commercial-icon.png?cf1515ea06ea238545939939df64181b";